import(/* webpackPrefetch: true */ "../utils/header.js");
import(/* webpackPrefetch: true */ "../utils/footer.js");
import(/* webpackPrefetch: true */ "../utils/cart.js");
import(/* webpackPrefetch: true */ "../utils/checkout.js");
import(
  /* webpackPrefetch: true */ /* webpackChunkName: 'swiper' */ "../utils/swiper.js"
);
import JQuery from "jquery";
import { Collapse, Modal } from "bootstrap";
import { fontAwesomeLoad } from "root/utils/fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons/faShoppingCart";
import { faHeart } from "@fortawesome/free-solid-svg-icons/faHeart";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons/faMapMarkerAlt";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons/faPhoneAlt";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faPinterest } from "@fortawesome/free-brands-svg-icons/faPinterest";
import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";

fontAwesomeLoad(".fa-chevron-down", faChevronDown);
fontAwesomeLoad(".fa-shopping-cart", faShoppingCart);
fontAwesomeLoad(".fa-heart", faHeart);
fontAwesomeLoad(".fa-user", faUser);
fontAwesomeLoad(".fa-search", faSearch);
fontAwesomeLoad(".fa-map-marker-alt", faMapMarkerAlt);
fontAwesomeLoad(".fa-phone-alt", faPhoneAlt);
fontAwesomeLoad(".fa-envelope", faEnvelope);
fontAwesomeLoad(".fa-facebook", faFacebook);
fontAwesomeLoad(".fa-twitter", faTwitter);
fontAwesomeLoad(".fa-instagram", faInstagram);
fontAwesomeLoad(".fa-pinterest", faPinterest);
fontAwesomeLoad(".fa-youtube", faYoutube);
fontAwesomeLoad(".fa-eye", faEye);
fontAwesomeLoad(".fa-times", faTimes);
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
window.jQuery = JQuery;

jQuery(document).ready(function ($) {
  $(".variation-btn").click(function () {
    let value = $(this).data("value");

    let attribute = $(this).closest(".variation-buttons").data("attribute");

    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    $('select[name="attribute_' + attribute + '"]')
      .val(value)
      .trigger("change");
  });

  /* clear variation */

  $(".reset_variations").click(function () {
    $(".variation-btn").removeClass("active");
  });
  // Perform search function
  function performSearch(searchQuery) {
    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "GET",
      data: {
        action: "search_posts",
        s: searchQuery,
      },
      success: function (response) {
        $("#search-results").html(response);

        var newUrl = "/search?search=" + encodeURIComponent(searchQuery);
        window.history.pushState({ path: newUrl }, "", newUrl);

        $("#search").val(searchQuery);
        $("#search").attr("placeholder", searchQuery);
      },
      error: function () {
        $("#search-results").html(
          "<p>There was an error processing your request.</p>",
        );
      },
    });
  }

  // On form submit, trigger the search
  if ($("#searchform").length) {
    $("#searchform").on("submit", function (e) {
      e.preventDefault();
      var searchQuery = $("#search").val();
      performSearch(searchQuery);
    });
  }

  // On page load, perform search if query in URL
  $(window).on("load", function () {
    var urlParams = new URLSearchParams(window.location.search);
    var searchQuery = urlParams.get("search");
    if (searchQuery) {
      performSearch(searchQuery);
      $("#search").attr("placeholder", searchQuery);
    }
  });

  // Handle back/forward navigation
  window.onpopstate = function (event) {
    if (event.state && event.state.path) {
      var urlParams = new URLSearchParams(event.state.path.split("?")[1]);
      var searchQuery = urlParams.get("search");
      if (searchQuery) {
        $("#search").val(searchQuery);
        $("#search").attr("placeholder", searchQuery);
        performSearch(searchQuery);
      }
    }
  };

  // Tab switching
  if ($(".tablink").length) {
    $(".tablink").click(function () {
      $(".tablink").removeClass("active");
      $(this).addClass("active");

      $(".tab-pane").removeClass("active");
      var tabIndex = $(this).index();
      $(".tab-pane").eq(tabIndex).addClass("active");
    });
  }

  //Mini cart

  // Open mini cart
  $(".open-mini-cart").on("click", function (e) {
    e.preventDefault();
    $(".mini-cart, .mini-cart-overlay").addClass("open");
  });

  // Close mini cart
  $(".close-mini-cart, .mini-cart-overlay").on("click", function () {
    $(".mini-cart, .mini-cart-overlay").removeClass("open");
  });
  $(document.body).on("added_to_cart removed_from_cart", function () {
    // Refresh mini cart content
    $(".mini-cart-content").load(
      wc_add_to_cart_params.wc_ajax_url.replace(
        "%%endpoint%%",
        "get_refreshed_fragments",
      ) + " .mini-cart-content > *",
    );

    // Update cart count
    $(".cart-count").text(wc_add_to_cart_params.cart_count);
  });
  // End mini cart
  // gallery fancybox
  $(".woocommerce-product-gallery__image a").attr("data-fancybox", "gallery");

  Fancybox.bind('[data-fancybox="gallery"]', {
    Toolbar: true,
    Thumbs: true,
  });
});

// Placeholder typing effect
const placeholders = [
  "Tìm kiếm bài viết...",
  "Nhập từ khóa bạn muốn...",
  "Tìm kiếm theo danh mục...",
];
const searchInput = document.getElementById("searchInput");
const searchInput2 = document.getElementById("searchInput2");

function typePlaceholder(inputElement, index) {
  if (!inputElement) {
    console.error(`Không tìm thấy phần tử input tại index ${index}!`);
    return;
  }

  let currentIndex = 0;
  let typingIndex = 0;
  let typingSpeed = 50;
  let deletingSpeed = 50;

  function startTyping() {
    const placeholder = placeholders[currentIndex];
    inputElement.placeholder = "";

    function type() {
      if (typingIndex < placeholder.length) {
        inputElement.placeholder += placeholder[typingIndex];
        typingIndex++;
        setTimeout(type, typingSpeed);
      } else {
        setTimeout(startDeleting, 1500);
      }
    }

    type();
  }

  function startDeleting() {
    function deleteText() {
      if (inputElement.placeholder.length > 0) {
        inputElement.placeholder = inputElement.placeholder.slice(0, -1);
        setTimeout(deleteText, deletingSpeed);
      } else {
        currentIndex = (currentIndex + 1) % placeholders.length;
        typingIndex = 0;
        setTimeout(startTyping, 500);
      }
    }

    deleteText();
  }

  startTyping();
}

if (searchInput) {
  typePlaceholder(searchInput, 0);
}
if (searchInput2) {
  typePlaceholder(searchInput2, 1);
}

const currentUrl = window.location.href;
const links = document.querySelectorAll("a");

links.forEach((link) => {
  if (currentUrl.includes(link.href)) {
    link.classList.add("active");
  }
});

const phrases = ["Xin chào", "こんにちは", "您好", "Bonjour"];

const textElement = document.querySelector(".title-top-footer");

if (textElement) {
  const typingSpeed = 100;
  const delayBetweenPhrases = 2000;

  let currentIndex = 0;
  let charIndex = 0;

  function typePhrase() {
    if (charIndex < phrases[currentIndex].length) {
      textElement.textContent += phrases[currentIndex][charIndex];
      charIndex++;
      setTimeout(typePhrase, typingSpeed);
    } else {
      setTimeout(clearPhrase, delayBetweenPhrases);
    }
  }

  function clearPhrase() {
    if (charIndex > 0) {
      textElement.textContent = textElement.textContent.slice(0, -1);
      charIndex--;
      setTimeout(clearPhrase, typingSpeed);
    } else {
      currentIndex = (currentIndex + 1) % phrases.length;
      typePhrase();
    }
  }

  typePhrase();
}

// my account page collapse

document.addEventListener("DOMContentLoaded", function () {
  const card = document.querySelector(".js-auth");
  if (!card) return;

  document.querySelectorAll(".btn-switch").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.dataset.target === "register") {
        card.classList.remove("is-login");
        card.classList.add("is-register");
      } else {
        card.classList.remove("is-register");
        card.classList.add("is-login");
      }
    });
  });
});


